import { simpleClient } from 'services/apiGatewayClient';
import { IMessage } from '../../entities';

const client = simpleClient<any>();

export async function toggleUserStatus(url: string, enabled: boolean): Promise<IMessage> {
  return await client.put(url, { enabled }).then(
    (items): IMessage => {
      return items.entity;
    },
  );
}
